import validate from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "restrict-email-confirm": () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/middleware/restrict-email-confirm.ts"),
  "role-restrict": () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/middleware/role-restrict.ts"),
  "tariff-restrict": () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/middleware/tariff-restrict.ts"),
  "sidebase-auth": () => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}